import React from 'react';
import AnimatedSection from '../common/AnimatedSection';

const IndustryLandscape = () => {
    return (
        <section style={styles.altSection}>
            <div style={styles.container}>
                <AnimatedSection animation="fadeIn">
                    <h2 style={styles.sectionTitle}>Industry <span style={styles.highlight}>Landscape</span></h2>
                    <div style={styles.sectionDivider}></div>
                    
                    <div style={styles.industryGrid}>
                        <div style={styles.industryCard}>
                            <div style={styles.industryIconWrapper}>
                                <i className="fas fa-chart-line" style={styles.industryIcon}></i>
                            </div>
                            <h3 style={styles.cardTitle}>Market Growth</h3>
                            <p style={styles.cardText}>
                                The elevator market in India is valued at <strong>USD 1.2 billion</strong>, with over 50,000 
                                units installed annually, and projected to grow at a CAGR of 8%.
                            </p>
                        </div>
                        
                        <div style={styles.industryCard}>
                            <div style={styles.industryIconWrapper}>
                                <i className="fas fa-building" style={styles.industryIcon}></i>
                            </div>
                            <h3 style={styles.cardTitle}>Market Structure</h3>
                            <p style={styles.cardText}>
                                The market is split between organized (60%) and unorganized sectors (40%), with companies like 
                                Dee Cee Elevators setting quality standards.
                            </p>
                        </div>
                        
                        <div style={styles.industryCard}>
                            <div style={styles.industryIconWrapper}>
                                <i className="fas fa-globe" style={styles.industryIcon}></i>
                            </div>
                            <h3 style={styles.cardTitle}>Global Potential</h3>
                            <p style={styles.cardText}>
                                The global elevator market is valued at <strong>USD 90 billion</strong>, with significant growth 
                                potential in emerging economies like India.
                            </p>
                        </div>
                        
                        <div style={styles.industryCard}>
                            <div style={styles.industryIconWrapper}>
                                <i className="fas fa-cogs" style={styles.industryIcon}></i>
                            </div>
                            <h3 style={styles.cardTitle}>Innovation Focus</h3>
                            <p style={styles.cardText}>
                                The industry is rapidly adopting IoT, energy-efficient systems, and smart features to meet 
                                evolving customer demands.
                            </p>
                        </div>
                    </div>
                </AnimatedSection>
            </div>
        </section>
    );
};

const styles = {
    altSection: {
        padding: '90px 0',
        backgroundColor: '#f8fafc',
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
    },
    sectionTitle: {
        fontSize: '2.5rem',
        fontWeight: '800',
        textAlign: 'center',
        marginBottom: '15px',
        color: '#2c3e50',
    },
    highlight: {
        color: '#163ba2',
    },
    sectionDivider: {
        width: '80px',
        height: '4px',
        backgroundColor: '#163ba2',
        margin: '0 auto 50px',
        borderRadius: '2px',
    },
    industryGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '30px',
        marginTop: '30px',
    },
    industryCard: {
        backgroundColor: '#ffffff',
        padding: '30px 25px',
        borderRadius: '10px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
        textAlign: 'center',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    },
    industryIconWrapper: {
        width: '70px',
        height: '70px',
        backgroundColor: '#ebf0ff',
        color: '#163ba2',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 20px',
    },
    industryIcon: {
        fontSize: '28px',
    },
    cardTitle: {
        fontSize: '1.3rem',
        fontWeight: '700',
        marginBottom: '15px',
        color: '#2c3e50',
    },
    cardText: {
        fontSize: '1rem',
        color: '#64748b',
        lineHeight: '1.6',
    },
    '@media (max-width: 992px)': {
        sectionTitle: {
            fontSize: '2.2rem',
        },
    },
    '@media (max-width: 820px)': {
        altSection: {
            padding: '70px 0',
        },
        sectionTitle: {
            fontSize: '2rem',
        },
    },
    '@media (max-width: 576px)': {
        altSection: {
            padding: '50px 0',
        },
        sectionTitle: {
            fontSize: '1.8rem',
        },
    }
};

export default IndustryLandscape;